/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LogTeamMeetingResult
 */
export interface LogTeamMeetingResult {
  /**
   *
   * @type {string}
   * @memberof LogTeamMeetingResult
   */
  teamMemberMeetingId: string;
}

/**
 * Check if a given object implements the LogTeamMeetingResult interface.
 */
export function instanceOfLogTeamMeetingResult(
  value: object,
): value is LogTeamMeetingResult {
  if (
    !("teamMemberMeetingId" in value) ||
    value["teamMemberMeetingId"] === undefined
  )
    return false;
  return true;
}

export function LogTeamMeetingResultFromJSON(json: any): LogTeamMeetingResult {
  return LogTeamMeetingResultFromJSONTyped(json, false);
}

export function LogTeamMeetingResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LogTeamMeetingResult {
  if (json == null) {
    return json;
  }
  return {
    teamMemberMeetingId: json["teamMemberMeetingId"],
  };
}

export function LogTeamMeetingResultToJSON(json: any): LogTeamMeetingResult {
  return LogTeamMeetingResultToJSONTyped(json, false);
}

export function LogTeamMeetingResultToJSONTyped(
  value?: LogTeamMeetingResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamMemberMeetingId: value["teamMemberMeetingId"],
  };
}
